/**
 * @description: 账号充值的平台类型；
 */
export const platformEnum = {
  androidUnion: 1,
  androidRelease: 2,
  iosUnion: 3,
  iosRelease: 4,
  oversea: 5
}

export const mediaTypeEnum = {
  GDT: 16,
  TOUTIAO: 10
}
/**
 * @description: 账号充值的平台类型列表；
 */
export const platformsList = [
  { label: '安卓联运', value: platformEnum.androidUnion },
  { label: '安卓发行', value: platformEnum.androidRelease },
  { label: 'IOS联运', value: platformEnum.iosUnion },
  { label: 'IOS发行', value: platformEnum.iosRelease },
  { label: '海外投放', value: platformEnum.oversea }
]

/**
 * @description: 批量充值、转账处理方式
 */
export const batchTypeEnum = {
  RECHARGE: 1, // 充值
  TRANSFER_IN: 2, // 转入
  TRANSFER_OUT: 3 // 转出
}

export const batchTypeList = [
  { label: '账号充值', value: batchTypeEnum.RECHARGE },
  { label: '账号转入', value: batchTypeEnum.TRANSFER_IN },
  { label: '账号转出', value: batchTypeEnum.TRANSFER_OUT }
]

export const gdtFundTypeEnum = {
  CREDIT_ROLL: 'FUND_TYPE_CREDIT_ROLL',
  CASH: 'FUND_TYPE_CASH',
  GIFT: 'FUND_TYPE_GIFT',
  VIRTUAL: 'FUND_TYPE_COMPENSATE_VIRTUAL',
  SPECIAL_GIFT: 'FUND_TYPE_SPECIAL_GIFT'
}

/**
 * @description: 腾讯广告资金类型
 */
export const gdtFundType = [
  { label: '授信余额', value: gdtFundTypeEnum.CREDIT_ROLL },
  { label: '现金余额', value: gdtFundTypeEnum.CASH },
  { label: '赠送余额', value: gdtFundTypeEnum.GIFT },
  { label: '补偿虚拟金', value: gdtFundTypeEnum.VIRTUAL },
  { label: '专项充值金', value: gdtFundTypeEnum.SPECIAL_GIFT }
]

export const toutiaoFundTypeEnum = {
  CREDIT_BID: 'CREDIT_BID',
  PREPAY_BID: 'PREPAY_BID',
  GRANT: 'GRANT'
}
/**
 * @description: 头条资金类型
 */
export const toutiaoFundType = [
  { label: '授信余额', value: toutiaoFundTypeEnum.CREDIT_BID },
  { label: '现金余额', value: toutiaoFundTypeEnum.PREPAY_BID },
  { label: '赠送余额', value: toutiaoFundTypeEnum.GRANT }
]
